<template>
  <section>
    {{ name }}
    <a :href='invite_link'>Invite Link to App</a>

    <div id='card_container'>
      <v-img src="@/assets/images/debit_card_template.png" style="max-height: 300px" contain></v-img>
      <span id='card_number'>{{ card_number_grouped }}</span>
      <span id='expiry'>{{ card_details.expiry_month }} / {{ card_details.expiry_year }}</span>
      <span id='cvc'>CVC {{ card_details.cvc }}</span>
    </div>

    <h3>Current Balance {{ account_balance }}</h3>

    <h3>Transactions</h3>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
        :headers="headers"
        :items="transactions"
        item-key="id"
        :search="search"
        >
    </v-data-table>
    
  </section>
</template>

<script>

export default {
    props: ['user','api_prefix', 'child_customer_id'],
    data() {
        return {
            loading: true,
            account_balance: 0,
            name: null,
            search: null,
            invite_link: null,
            headers: [{ text: 'Date', value: 'date', sortable: true }, { text: 'Description', value: 'description' }, { text: 'Amount', value: 'amount', sortable: true }],
            transactions: [],
            card_details: {},
        };
    },
    computed: {
      card_number_grouped: function()
      {
        if(this.card_details.number!=null)
        {
          return this.card_details.number.substr(0, 4) + '  ' + this.card_details.number.substr(4, 4) + '  ' + this.card_details.number.substr(8, 4) + '  ' + this.card_details.number.substr(12, 4)
        }
        else
        {
          return null
        }
      }
    },
    methods: 
    {
      async get_data()
      {
        let self = this
        self.loading = true
        var response = await this.$http.get(this.api_prefix + '/card',
        {
          params: {
            //optional child_customer_id if a parent is viewing
            child_customer_id: self.child_customer_id
          }
        });

        if(response.data!=null)
        {
          //daily data in bar chart
          self.name = response.data.result.name
          self.card_details = response.data.result.card_details
          self.transactions = response.data.result.transactions
          self.account_balance = response.data.result.account_balance
          self.invite_link = response.data.result.invite_link
        }
        self.loading = false
      }
    },
    mounted() 
    {
      let self = this;

      window.analytics.track('Page Visited', 
      {
        title: 'Card',
      });

      self.get_data()
    }
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  #card_number
  {
    color: black;
    position: absolute;
    left: 8%;
    top: 54%;
    font-size: 18px;
  }
  #expiry
  {
    color: black;
    position: absolute;
    left: 8%;
    top: 80%;
  }
  #cvc
  {
    color: black;
    position: absolute;
    left: 60%;
    top: 80%;
  }
}
@media only screen and (min-width: 768px) {
#card_number
{
  color: black;
  position: absolute;
  left: 38%;
  top: 54%;
  font-size: 32px;
}
#expiry
{
  color: black;
  position: absolute;
  left: 38%;
  top: 80%;
}
#cvc
{
  color: black;
  position: absolute;
  left: 58%;
  top: 80%;
}
}
#card_container {
  position: relative;
  text-align: left;
  text-shadow: -1px -1px 1px #fff, 1px 1px 1px #000;
  color: #9c8468;
}

#loading_spinner
{
  margin: 0 auto;
  display: inherit;
}
</style>
